import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';

export default function ActAsDialog({ organisation, organisations = [], onTargetChange, onSubmit, onClose, busy, error }) {
  const [reason, setReason] = useState('');
  useEffect(() => { setReason(''); }, [organisation?.id]);
  const hasTargets = organisations.length > 0;
  return (
    <Dialog open={!!organisation} onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
      <DialogContent aria-describedby="act-as-description">
        <DialogHeader>
          <DialogTitle>Act as a customer</DialogTitle>
          <DialogDescription id="act-as-description">
            Enter a reason for this customer support session. It will be recorded in the audit log.
          </DialogDescription>
        </DialogHeader>
        {hasTargets ? (
          <label htmlFor="act-as-organisation" className="block text-sm font-medium text-foreground">
            Customer organisation
            <select
              id="act-as-organisation"
              value={organisation?.id || ''}
              onChange={(event) => onTargetChange?.(organisations.find(o => o.id === event.target.value))}
              disabled={busy}
              className="mt-1 min-h-11 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring"
            >
              {organisations.map(org => <option key={org.id} value={org.id}>{org.name}</option>)}
            </select>
          </label>
        ) : (
          <p className="text-base font-semibold text-foreground">{organisation?.name}</p>
        )}
        <label htmlFor="act-as-reason" className="block text-sm font-medium text-foreground">
          Reason
          <textarea
            id="act-as-reason"
            autoFocus
            minLength={10}
            maxLength={500}
            value={reason}
            onChange={e => setReason(e.target.value)}
            rows={4}
            className="mt-1 min-h-28 w-full rounded-lg border border-input bg-background p-3 text-sm text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring"
            aria-describedby="act-as-reason-help act-as-error"
          />
        </label>
        <p id="act-as-reason-help" className="text-xs text-muted-foreground">10–500 characters.</p>
        {error && <p id="act-as-error" className="text-sm text-red-800" role="alert">{error}</p>}
        <DialogFooter>
          <button type="button" onClick={onClose} disabled={busy} className="min-h-11 rounded-lg border border-border px-4 py-2 text-sm text-foreground hover:bg-muted disabled:opacity-50">Cancel</button>
          <button type="button" onClick={() => onSubmit(reason)} disabled={busy || !organisation || reason.trim().length < 10} className="min-h-11 rounded-lg bg-teal-700 px-4 py-2 text-sm font-semibold text-white hover:bg-teal-800 disabled:opacity-50">{busy ? 'Starting…' : 'Start act-as session'}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
